import React, { useEffect, useRef } from "react";

const GooglePlacesInput = ({
  label, // Label opcional
  value, // Valor controlado para el campo de texto
  onChange, // Función para manejar el cambio del valor
  placeholder = "Busca un lugar", // Placeholder opcional
  bg = "#F9FAFB",
  width = "100%",
}) => {
  const inputRef = useRef(null); // Referencia al input de búsqueda

  useEffect(() => {
    if (window.google && window.google.maps) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          types: ["establishment", "geocode"], // Tipo de búsqueda (puedes cambiarlo según necesidad)
          componentRestrictions: { country: "py" }, // Restricciones por país
        }
      );

      // Evento para manejar cuando se selecciona un lugar
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();
        onChange(place.name + ", " + place.vicinity); // Actualiza el valor con el nombre del lugar seleccionado
        console.log("Lugar seleccionado:", place);
      });
    }
  }, [onChange]);

  // Maneja el cambio en el input
  const handleInputChange = (e) => {
    const query = e.target.value;
    onChange(query); // Actualiza el valor controlado
  };

  return (
    <div className="poppins-medium flex flex-col space-y-2">
      {/* Label del campo */}
      {label && (
        <label className="text-[#8F99A6] text-xs tracking-wider">{label}</label>
      )}

      <input
        ref={inputRef}
        type="text"
        value={value} // Usamos el valor controlado
        onChange={handleInputChange} // Llama a onChange para actualizar el valor
        placeholder={placeholder} // Placeholder configurable
        className={`w-[${width}] py-3 px-4 rounded-[9px] bg-[${bg}] text-[10px] poppins-regular placeholder-[#C9C9C9] focus:outline-none focus:ring-2 focus:ring-blue-500 tracking-wider`}
      />
    </div>
  );
};

export default GooglePlacesInput;
